import { ProtectedRoute } from "@/components/protected-route";
import { Outlet } from "react-router";

export const OrdersLayout = () => {
  return (
    <ProtectedRoute>
      <Outlet />
    </ProtectedRoute>
  );
};
